import { format } from 'date-fns';

import { Paragraph } from '../../../common/Atoms/Typography/Paragraph';
import { Pill } from '../../../common/Atoms/Pill';
import { useGetAssistantConversationsQuery } from '../../services/api/assistantApi/assistant';
import { Spinner } from '../Common/Spinner';

interface AssistantHistoryProps {
  organisationId: string | undefined;
  activeConversationId: number | undefined;
  onSelect: (conversationId: number) => void;
}

/** Past chats for this user and organisation, newest first */
export function AssistantHistory({ organisationId, activeConversationId, onSelect }: AssistantHistoryProps) {
  const { data: conversations, isLoading } = useGetAssistantConversationsQuery(
    { organisationId: organisationId as string },
    { skip: !organisationId },
  );

  const past = (conversations ?? []).filter(conversation => conversation.id !== activeConversationId && conversation.messageCount > 0);

  return (
    <div className={ `flex-1 overflow-y-auto p-4` }>
      { isLoading && <Spinner /> }
      {
        !isLoading && !past.length &&
        <Paragraph
          size={ `sm` }
          variant={ `secondary` }
        >
          { `No past chats yet. Chats appear here when you start a new one.` }
        </Paragraph>
      }
      <ul className={ `divide-y divide-slate-200 rounded-xl border border-slate-200 bg-white` }>
        {
          past.map(conversation => (
            <li key={ conversation.id }>
              <button
                type={ `button` }
                className={ `flex w-full items-start justify-between gap-3 px-4 py-3 text-left hover:bg-slate-50` }
                onClick={ () => onSelect(conversation.id) }
              >
                <div className={ `min-w-0` }>
                  <p className={ `truncate text-sm text-gray-800` }>{ conversation.preview ?? `(no messages)` }</p>
                  <Paragraph
                    size={ `xs` }
                    variant={ `secondary` }
                  >
                    { `${format(new Date(conversation.updatedAt), `PPp`)} · ${conversation.messageCount} messages` }
                  </Paragraph>
                </div>
                <Pill
                  message={ conversation.status }
                  color={ conversation.status === `active` ? `green` : `gray` }
                  className={ `shrink-0 capitalize` }
                />
              </button>
            </li>
          ))
        }
      </ul>
    </div>
  );
}
